<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">
  <div class="mb-2 pr-1 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 bg-zinc-100 dark:bg-zinc-900">
 <div class="flex items-center gap-2">
  
  <div class="relative">
    <input type="text" [(ngModel)]="search" placeholder="Search.." class="pl-8" />
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>
  </div>
  
  <div>
    <div>
      <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
        (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" [readOnly]="true" />
      <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
    </div>
    
  </div>
    <div>
      <ng-select class="w-full sm:w-44" [(ngModel)]="selectedFundingSource" (change)="filterFundingsourceBySelection()" [clearable]="false"
        [searchable]="true" >
        <ng-option value ="">Select FS</ng-option>
        <ng-option *ngFor="let fundingsourc of fundingSource" [value]="fundingsourc">{{fundingsourc?.title | titlecase}}
        </ng-option>
      </ng-select>
    </div>
   <div>
    <ng-select class="w-full sm:w-44" [(ngModel)]="selectedCompany" (change)="filterCompaniesBySelection()"  [clearable]="false">
      <ng-option value="">Select Company</ng-option>
      <ng-option *ngFor="let company of allCompanies" [value]="company">{{ company.name | titlecase }}</ng-option>
    </ng-select>
  </div>
  </div>
    <div class="flex flex-col sm:flex-row gap-2 items-center">
      <div *ngIf="trips && trips.length">
        <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (trips != 50? (50
          -trips.length) : 0) }} entries
        </h1>
      </div>
      <div
                class="inline-flex flex-wrap p-1 rounded-lg gap-0.5 bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg focus:outline-none">

                <div [ngClass]="source === 'original' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('original')" class="cursor-pointer">
                    Original
                </div>
                <div [ngClass]="source === 'billing' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('billing')" class="cursor-pointer">
                    Company Adjusted
                </div>
                <div [ngClass]="source === 'fundingsource' ? 'btn btn-secondary sm:text-xs/5' : 'btn-outline  dark:hover:bg-zinc-700/20 border-transparent btn-outline-secondary sm:text-xs/5'"
                    class="cursor-pointer" (click)="changeSource('fundingsource')" class="cursor-pointer">
                    Funding Source Adjusted
                </div>
            </div>
         
    <div class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
      <div>
        <button [appToolTip]="'Filters'" type="button" (click)="toggleDropdown($event)" class="btn btn-secondary" id="menu-button"
          aria-expanded="true" aria-haspopup="true">
    
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
          </svg>
          <!-- <span 
                 *ngIf="(selectedSpaceType && selectedSpaceType.length > 0) || isShowTime"
                  class="flex absolute h-3 w-3 -top-1 -right-1">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-red-500"></span>
                  <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                </span> -->
        </button>
      </div>
    
    
      <div *ngIf="isDropdownOpen"
        class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
        role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
        <div class="p-3 grid grid-cols-1 gap-2" role="none">
    
          <button (click)="partnerPayReport('all')" class="btn btn-secondary">
            Download
          </button>
          <button (click)="partnerPayReport('company')" class="btn btn-secondary">
            Download Company Wise
          </button>
          <button (click)="partnerPayReport('fundingSource')" class="btn btn-secondary">
            Download FS Wise
          </button>
        </div>
      </div>
    </div>
        </div>
  
  </div>

  <h2><label class="font-bold" for="">Actual Amount</label></h2>
  <div class="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate"> Trips </div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{overviewData?.totalTrips || '0' }}
          </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total FS</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{overviewData?.actualFSTotal?.toFixed(2) || '0' }}
          </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Company</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.actualCompanyTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Commission</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.actualCommissionTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Pre  Special</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.preSpecialTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Special</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.specialTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
  </div>
    <h2><label class="font-bold" for="">Flat Amount</label></h2>
  <div class="grid grid-col-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate"> Trips </div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{overviewData?.totalTrips || '0' }}
          </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total FS</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate"> {{overviewData?.flatFSTotal?.toFixed(2) || '0' }}
          </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Company</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.flatCompanyTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Commission</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.flatCommissionTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Pre Special</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.preSpecialTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
    <div class="rounded-2xl bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 p-4">
      <dl class="flex items-center">
        <dt class="grid place-content-center size-12 flex-shrink-0 rounded-lg bg-gray-950/5 dark:bg-white/5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="h-8 w-8 text-base-dark">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </dt>
        <dd class="w-full ml-4 truncate text-right">
          <div class="text-xs-light flex-1 truncate">Total Special</div>
          <div class="text-xl font-bold text-base-dark flex-1 truncate">
            {{overviewData?.specialTotal?.toFixed(2) || '0'}} </div>
        </dd>
      </dl>
    </div>
  </div>

  <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
      <div class="flow-root h-full overflow-y-auto">
        <div class="-my-2">
          <div class="inline-block min-w-full py-2 align-middle">
            <table class="min-w-full border-separate border-spacing-0">
              <thead>
                <tr>
                       <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    #</th>
                  <!-- <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Action
                  </th> -->
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Funding Source</th>
                    <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Company</th>
                    <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Driver</th>
                          <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Status</th>
                    <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Reference ID</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Member</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Service Date</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Miles</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Space Type</th>
                  <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    LOS</th>
                     <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Pre Special Rate
                    </th>
                      <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Special Rate
                    </th>
                    <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Flat FS</th>
                     <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Flat Company</th>
                    <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Actual FS
                    </th>
                                        <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Actual Company
                    </th>
                                        <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Flat Commission
                    </th>
                                        <th
                      class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Actual Commission
                    </th>
                </tr>
              </thead>
              <tbody>
              <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10" *ngFor="let trip of trips | filter: search let i=index">
               <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{i+1}}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <span *ngIf="trip.fundingsource; else elseBlock">
                    {{trip.fundingsource.title | titlecase}}
                  </span>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <span *ngIf="trip?.company else elseBlock">
                    {{ (trip?.company.name | titlecase) || 'N/A' }}
                  </span>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  {{trip?.driver?.displayName ? (trip?.driver?.displayName | titlecase ) : 'N/A'}}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <div class="space-x-1">
                  <div [ngClass]="{
                                                          'badge-danger': trip?.status === 'cancelled' || trip?.status === 'reroute',
                                                          'badge-success': trip?.status !== 'cancelled' && trip?.status !== 'reroute'
                                                        }">
                    {{trip.status | titlecase }}
                  </div>
                  <ng-container *ngIf="trip.flags && trip.status == 'cancelled'" >

                    <span *ngIf="trip.flags.isBillable"
                      class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FEA405]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FEA405] sm:text-xs/5 forced-colors:outline">
                      Billable </span>
                    <!-- noshow -->
                    <span *ngIf="trip.flags.isNoShow"
                      class="inline-flex items-center gap-x-1.5 rounded-md bg-[#FF8080]/10 px-1.5 py-0.5 text-sm/5 font-medium text-[#FF8080] sm:text-xs/5 forced-colors:outline">
                      No Show </span>
                     
                  </ng-container>
                   </div>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <span>
                   {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
                  </span>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <span >
                    {{(trip?.member?.displayName) | titlecase}}
                  
                  </span>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <div class="flex flex-col gap-0 leading-tight">
                    <span>{{trip?.pickup.time | date: 'MM/DD/YYYY HHmm'}}</span>
                  </div>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                   {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : '' }}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <span *ngIf="trip.spaceType; else elseBlock">
                    {{trip.spaceType.title | uppercase}}
                  </span>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  <span *ngIf="trip.levelOfService; else elseBlock">
                    {{trip.levelOfService.title | uppercase}} </span>
                </td>
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                <div [ngClass]="trip?.status === 'completed' && trip?.preSpecialTotal > 0 ? 'font-bold' : (trip?.status === 'cancelled' ? 'line-through opacity-60' : '')">
                 ${{trip?.preSpecialTotal?.toFixed(2) || 0}}
                </div>
              </td>
              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                <div [ngClass]="trip?.status === 'completed' && trip?.specialTotal > 0 ? 'font-bold' : (trip?.status === 'cancelled' ? 'line-through opacity-60' : '')">
                 ${{trip?.specialTotal?.toFixed(2) || 0}}
                </div>
              </td>

              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                <div [ngClass]="(trip?.status === 'completed' && trip?.preSpecialTotal > 0) || trip?.status === 'cancelled' ? 'line-through opacity-60' : ''">
                  ${{trip?.flatFSTotal.toFixed(2) || '0'}}
                </div>
              </td>

              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                <div [ngClass]="(trip?.status === 'completed' && trip?.specialTotal > 0) || trip?.status === 'cancelled' ? 'line-through opacity-60' : ''">
                  ${{trip?.flatCompanyTotal.toFixed(2) || '0'}}
                </div>
              </td>

              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">
                <div>
                  $ {{trip?.actualFSTotal.toFixed(2) || '0'}}
                </div>
              </td>

              <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">
                <div>
                  ${{trip?.actualCompanyTotal.toFixed(2) || '0'}}
                </div>
              </td>
                      <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                  <div class="flex flex-col gap-0 leading-tight">
                    <span>
                        {{ trip.flatCommissionTotal ? ('$' + (trip.flatCommissionTotal | number:'1.2-2')) : '0' }}
                    </span>
                  </div>
                </td>
                 <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap font-bold bg-zinc-50 dark:bg-zinc-950">
                  <div class="flex flex-col gap-0 leading-tight">
                    <span>
                      {{ trip.actualCommissionTotal ? ('$' + (trip.actualCommissionTotal | number:'1.2-2')) : '0' }}
                    </span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
              <ng-template #elseBlock>N/A</ng-template>
          </div>
        </div>
       </div>
    </div>
  </div>
</section>